/*
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-04-30 13:54:49
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-06-11 20:04:36
 * @FilePath: /goldenSalesMobile/src/utils/wxpay.js
 * @Description: 微信支付方法封装(支付认证，回调)
 */
import Vue from 'vue'
import { Toast } from 'vant';
Vue.use(Toast);
function onBridgeReady(params, successCallBack, failCallBack) {
  // eslint-disable-next-line no-undef
  console.log(`88888<<<  params  >>>88888`);
  console.log(params);
  WeixinJSBridge.invoke(
    //微信支付的一些认证
    'getBrandWCPayRequest', {
      "appId": params.appId,   
      "timeStamp": params.timeStamp,     
      "nonceStr": params.nonceStr,   
      "package": params.package,
      "signType": params.signType,    
      "paySign": params.paySign
    },
    function (res) {
      console.log(`99999<<<  res  >>>99999`);
      console.log(res);
      //这个是支付成功的回调
      if (res.err_msg === "get_brand_wcpay_request:ok") {
        
        successCallBack()
      } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
        Toast('您已取消支付')
        failCallBack()
      } else if (res.err_msg === 'get_brand_wcpay_request:fail') {

        failCallBack()
      } else {
        alert(res.err_msg)
      }
    });
}

export function getBrandWCPayRequest(params, successCallBack, failCallBack) {
  //判断typeof WeixinJSBridge是否为undefind
  console.log(`55555<<<  typeof WeixinJSBridge  >>>55555`);
  console.log(typeof WeixinJSBridge);
  if (typeof WeixinJSBridge == "undefined"){
    // 注意：WeixinJSBridge内置对象在其他浏览器中无效。
    console.log(`77777<<<  params  >>>77777`);
    console.log(params);
    if( document.addEventListener ){
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
    }else if (document.attachEvent){
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady); 
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
    }
  } else {
    console.log(`66666<<<  params  >>>66666`);
    console.log(params);
    onBridgeReady(params, successCallBack, failCallBack)
  }
}